import React, { useEffect, useState } from 'react';
import { Button, Divider, Typography } from "@material-ui/core";
import toastError from "../../errors/toastError";

const AdMetaPreview = ({ image, title, body, sourceUrl, messageUser }) => {
  const [imgFailed, setImgFailed] = useState(false);
  useEffect(() => {
    setImgFailed(false);
  }, [image, title, body, sourceUrl, messageUser]);

  const handleAdClick = async () => {
    try {
      if (sourceUrl && sourceUrl.trim() !== "") {
        window.open(sourceUrl);
      }
    } catch (err) {
      toastError(err);
    }
  };

  const img = (image && String(image).trim()) || "";
  const hasDataImage = img && img.startsWith("data:image");
  const hasHttpImage = img && /^https?:\/\//i.test(img);
  const hasValidImage = Boolean(hasDataImage || hasHttpImage);
  const showThumb = hasValidImage && !imgFailed;

  return (
    <div style={{ minWidth: "250px" }}>
      <div>
        {showThumb && (
          <div style={{ float: "left" }}>
            <img
              src={img}
              alt="Thumbnail"
              onClick={handleAdClick}
              style={{ width: "100px", cursor: sourceUrl ? "pointer" : "default" }}
              onError={() => setImgFailed(true)}
            />
          </div>
        )}
        
        <div style={{ display: "flex", flexWrap: "wrap", marginLeft: showThumb ? "115px" : "0px" }}>
          {title && title.trim() !== "" && (
            <Typography 
              style={{ marginTop: "12px", marginBottom: "8px", width: "100%" }} 
              variant="subtitle1" 
              color="primary" 
              gutterBottom
            >
              <div>{title}</div>
            </Typography>
          )}
          
          {body && body.trim() !== "" && (
            <Typography 
              style={{ marginBottom: "8px", width: "100%" }} 
              variant="body2" 
              color="textSecondary" 
              gutterBottom
            >
              <div>{body}</div>
            </Typography>
          )}
          
          {messageUser && messageUser.trim() !== "" && (
            <Typography 
              style={{ marginBottom: "8px", width: "100%" }} 
              variant="subtitle2" 
              color="textSecondary" 
              gutterBottom
            >
              <div>{messageUser}</div>
            </Typography>
          )}
        </div>
        
        <div style={{ display: "block", content: "", clear: "both" }}></div>
        
        {sourceUrl && sourceUrl.trim() !== "" && (
          <div>
            <Divider />
            <Button
              fullWidth
              color="primary"
              onClick={handleAdClick}
            >
              Visualizar Anúncio
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdMetaPreview;
